import { useEffect } from "react";

import {
  Container,
  Footer,
  Card,
  SuccessIcon,
  Steps,
  Step,
  EmailBox,
  ButtonLogin,
  LogoCanto,
} from "./styles.js";
import logoCanto from "../../assets/logoCanto.png";
import ls from "../../services/localStorage/index";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faCheck,
  faEnvelope,
  faMicroscope,
  faHome,
} from "@fortawesome/free-solid-svg-icons";

function ResidentConfirmed() {
  useEffect(() => {
    const url = ls().get("url");
    const sessionToken = ls().get("sessionTokenResident");
    const residentToken = ls().get("residentDataToken");

    // Se algum dos itens não existir, redireciona
    if (!url || !sessionToken || !residentToken) {
      window.location.href = "https://www.cedap.com.br";
    }
  }, []);
  const emailContato = "residencia4@cedap.com.br";
  const handleContinue = () => {
    ls().del("residentDataToken");
    ls().del("sessionTokenResident");
    ls().del("url");
    window.location.href = "https://www.cedap.com.br";
  };
  return (
    <>
      <Container>
        <Card>
          <LogoCanto src={logoCanto} alt="Logo Cantoneira" />

          <SuccessIcon>
            <FontAwesomeIcon icon={faCheckCircle} />
          </SuccessIcon>

          <h1>Inscrição confirmada!</h1>
          <span className="subtitle">
            Etapa 2 de 3 · Residência Médica R4 em Patologia
          </span>

          <Steps>
            <Step className="completed">
              <span className="step-label">Etapa 1</span>
              <FontAwesomeIcon icon={faCheck} />
              <p>Inscrição recebida</p>
            </Step>

            <Step className="current">
              <span className="step-label">Etapa 2 · Atual</span>
              <FontAwesomeIcon icon={faMicroscope} />
              <p>Análise pela equipe</p>
            </Step>

            <Step>
              <span className="step-label">Etapa 3</span>
              <FontAwesomeIcon icon={faEnvelope} />
              <p>Contato por e-mail</p>
            </Step>
          </Steps>

          <EmailBox>
            <FontAwesomeIcon icon={faEnvelope} />

            <span>Fique atento ao e-mail:</span>
            <strong>{emailContato}</strong>
          </EmailBox>

          <p className="note">
            Verifique também a caixa de spam.
            <br />
          </p>

          <ButtonLogin type="button" onClick={handleContinue}>
            Voltar para Home <FontAwesomeIcon icon={faHome} />
          </ButtonLogin>
        </Card>
      </Container>

      <Footer>
        CEDAP · Programa de Residência Médica · Dúvidas? Encaminhe para:{" "}
        <strong>{emailContato}</strong>.
      </Footer>
    </>
  );
}

export default ResidentConfirmed;
